module.exports = __webpack_public_path__ + "static/FoundersGrotesk-Regular-6ed5c892a28c1a11dbabd4dd1e342589.ttf";